export enum ActionTypes {
    ADOBE_UI_UPDATED = 'ADOBE_UI_UPDATED',
    ADOBE_SCHEMA_INSTALLED = 'ADOBE_SCHEMA_INSTALLED',
    
}



// WEBPACK FOOTER //
// ./src/sub-projects/adobe/types/action-types.ts